import React from "react";
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Switch,
  Tooltip,
  Typography
} from "@mui/material";
import { IActions } from "./types";
import { accessProfileActionPermission } from "../../../Requests";
import useGlobalContext from "../../../Hooks/useGlobalContext";

interface IListActionsProps {
  actions: IActions[];
  activeActions: string[];
  idModule: number;
  idProfile: number;
  reloadActions: () => void;
  previewChange: (status: boolean, action: string) => void;
}

const ListActions: React.FC<IListActionsProps> = ({
  actions,
  activeActions,
  idModule,
  idProfile,
  reloadActions,
  previewChange,
}) => {
  const { setLoading } = useGlobalContext();

  const isActionActive = (actionName: string) => activeActions.includes(actionName);

  const handleToggle = async (
    status: boolean,
    actionId: number,
    moduleId: number,
    actionName: string
  ) => {
    setLoading?.(true);
    previewChange(status, actionName);

    const newStatus = status ? "active" : "inactive";

    await accessProfileActionPermission.post(`${idProfile}`, {
      status: newStatus,
      module_action_id: actionId,
      admin_modules_access_profile_id: idProfile,
      admin_modules_id: moduleId,
    });

    reloadActions();
  };

  return (
    <List disablePadding>
      {actions.map(({ description, name, id }, index) => {
        const isActive = isActionActive(name);

        return (
          <Box key={id}>
            <ListItem
              sx={{
                px: 2,
                py: 1,
                "&:hover": { backgroundColor: "#f9f9f9" },
                borderRadius: 1,
              }}
              secondaryAction={
                <Tooltip title={isActive ? "Desativar ação" : "Ativar ação"} placement="top">
                  <Switch
                    edge="end"
                    checked={isActive}
                    onChange={() => handleToggle(!isActive, id, idModule, name)}
                    inputProps={{ "aria-label": `Permissão para ${description}` }}
                  />
                </Tooltip>
              }
            >
              <ListItemText
                primary={
                  <Typography fontSize={14} fontWeight={500} color="text.primary">
                    {description}
                  </Typography>
                }
              />
            </ListItem>
            {index < actions.length - 1 && <Divider sx={{ mx: 2 }} />}
          </Box>
        );
      })}
    </List>
  );
};

export default ListActions;
